// extracted by mini-css-extract-plugin
export default {"container":"MyLocationBtn_container__BOYCl","icon":"MyLocationBtn_icon__YjZdq"};